<div class="modal-content">
  <div class="modal-header bg-info text-white">
    <h4 class="modal-title">Search for User</h4>
  </div>
  <div class="modal-body">
    <form
      #searchForm="ngForm"
      (ngSubmit)="searchForm.form.valid && searchForUser()"
    >
      <div class="row row-cols-1 row-cols-md-2">
        <div class="col mb-3">
          <label for="txtLast">Last Name</label
          ><input
            #lastName="ngModel"
            placeholder="required"
            type="text"
            name="txtLast"
            id="txtLast"
            class="form-control"
            [(ngModel)]="requestModel.LastName"
            ngbAutofocus
            required
            minlength="3"
            [disabled]="!isReady"
          />
          @if (
            ((lastName.touched && lastName.dirty) || searchForm.submitted) &&
            lastName.errors?.required
          ) {
            <small class="text-danger"> Last Name required </small>
          }
          @if (
            ((lastName.touched && lastName.dirty) || searchForm.submitted) &&
            !lastName.errors?.required &&
            lastName.errors?.minlength
          ) {
            <small class="text-danger"> Give me at least 3 letters </small>
          }
        </div>
        <div class="col mb-3">
          <label for="txtFirst">First Name</label>
          <input
            #firstName="ngModel"
            placeholder="optional"
            type="text"
            name="txtFirst"
            id="txtFirst"
            class="form-control"
            [(ngModel)]="requestModel.FirstName"
            [disabled]="!isReady"
          />
        </div>
      </div>
      <div class="row row-cols-1 row-cols-md-2">
        <div class="col">
          @if (!isReady) {
            <ngb-alert type="info" [dismissible]="false"
              ><fa-icon [icon]="icons.spinner" animation="spin-pulse"></fa-icon>
              Searching...</ngb-alert
            >
          }
        </div>
        <div class="col">
          <button
            type="submit"
            class="btn btn-sm btn-primary float-end"
            [disabled]="!isReady"
          >
            Search
          </button>
        </div>
      </div>
    </form>
    <hr />
    <div>
      <table class="table table-sm table-striped">
        <thead class="table-dark">
          <tr>
            <th>Name</th>
            <th>Title</th>
            <th>Select</th>
          </tr>
        </thead>
        <tbody>
          @for (result of searchResults; track result; let i = $index) {
            <tr>
              <td>{{ result.DisplayName }}</td>
              <td>{{ result.JobTitle }}</td>
              <td>
                <button
                  type="button"
                  class="btn btn-link"
                  (click)="selectUser(i)"
                >
                  Select
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button
      (click)="closeModal()"
      type="button"
      class="btn btn-secondary btn-sm"
      [disabled]="!isReady"
    >
      Cancel
    </button>
  </div>
</div>
